import axios from '../../service/index'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Divider, Table, Modal, message, Form, Input, Tabs,  Pagination, Select, Icon } from 'antd'
import './testquestions.less'
const { TabPane } = Tabs;
const { Option } = Select;
let urldown = process.env.REACT_APP_ENV === "production" ? process.env.REACT_APP_BASE_URL + 'video-wechat-manager/' : "http://test-videocadmin.codingke.com/video-wechat-manager/"
class TestQuestions extends Component {
  state = {
    showKnowName: false,
    showImport: false,
    content: '',
    topictype: '',
    loading: false,
    typecard: '1',
    iconLoading: false,
    showUpload: 'before',
    columns: [{
      title: '题干',
      dataIndex: 'content',
      align: 'left',
      key: 'content',
    },
    {
      title: '试题类型',
      width: 150,
      dataIndex: 'type',
      align: 'center',
      key: 'type',
      render: (record) => {
        return (
          <span>{record === 0?'单选题':'多选题'}</span>
        )
      }
    },
    {
      title: '操作',
      width: 120,
      align: 'center',
      render: (row) => {
        return (
          <div className="all-btn">
            <Button type="link" onClick={() => {
              let {questionId,knowId, pageNum} = this.state
              this.state.typecard === '1'?
              this.props.history.push('/type',{typeQ: 'edit',interviewId: row.id, questionId,knowId, pageNum}):
              this.props.history.push('/interview',{typeQ: 'edit',interviewId:row.id, questionId,knowId, pageNum})
            }}>编辑</Button>
            <Button type="link" className="red-color" onClick={() => {this.delInterview(row)}}>删除</Button>
          </div>
        )
      }
    }],
    intercolumns: [{
      title: '题干',
      dataIndex: 'content',
      align: 'left',
      key: 'content',
    },
    {
      title: '操作',
      width: 120,
      align: 'center',
      render: (row) => {
        return (
          <div className="all-btn">
            <Button type="link" onClick={() => {
              let {questionId,knowId, subjectName, pageNum} = this.state
              this.state.typecard === '1'?
              this.props.history.push('/type',{typeQ: 'edit',interviewId: row.id,subjectName: subjectName, questionId,knowId, pageNum}):
              this.props.history.push('/interview',{typeQ: 'edit',interviewId: row.id,subjectName: subjectName, questionId,knowId, pageNum})
            }}>编辑</Button>
            <Button type="link" className="red-color" onClick={() => {
              this.delInterview(row)
            }}>删除</Button>
          </div>
        )
      }
    }],
    token: localStorage.getItem('token'),
    dataSource: [],
    fileObj: {},
    excelUrl: '',
    knowId: '',
    questionId: '',
    subjectName: '',
    fileName: '',
    formdataObj: {},
    msgObj: {},
    total: 10,
    pageNum: 1,
    size: 10,
  }
  UNSAFE_componentWillMount() {
    console.log(this.props.tabnum)
    let {knowId, questionId, subjectName, pageNum} = this.props.location.state
    this.setState({knowId: knowId, questionId: questionId, subjectName, pageNum:pageNum||1, typecard: this.props.tabnum}, () => {
      this.InitQuestionList()
    })
  }
  componentWillUnmount() {
    this.setState({msgObj: {}, formdataObj: {},typecard: '1'})
  }
  InitQuestionList() {
    let params = {
      konwledgeId: this.state.knowId,
      pageNum: this.state.pageNum,
      pageSize: this.state.size,
      content: this.state.content,
      type: this.state.topictype,
      questionType: this.state.typecard
    }
    if(this.state.typecard === '2'){
      delete params.type
    }
    axios.post('/question/writing/list',params).then(res => {
      if (res.data.code === '200') {
        this.setState({dataSource: res.data.data.list,total: res.data.data.total})
      }
    })
  }
  pageChange = (current) => {
    console.log(current)
    this.setState({pageNum: current},() => {
      this.InitQuestionList()
    })
  }
  sizeChange = (current, size) => {
     
    this.setState({pageNum:1, size: size},() => {
      this.InitQuestionList()
    })
  }
  search = () => {
    this.InitQuestionList()
  }
  clearSearch = () => {
    this.setState({topictype: '', content:''})
    this.InitQuestionList()
  }
  delInterview(obj) {
    // console.log(obj)
      Modal.confirm({
        title: '删除',
        okText: "确认",
        cancelText: "取消",
        content: '删除后将不可恢复，请谨慎操作！确定要删除吗？',
        onOk: () => {
          axios.get(`/question/delete/${obj.id}`).then(res => {
            console.log(res.data)
            if(res.data.code !== '200') return message.error(res.data.msg)
            message.success('删除成功')
            this.InitQuestionList()
          })
        },
      });
  }
  submitOk(e) {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if(!err) {
        console.log(values)
        // if(typecard == '1'){}
        // this.props.form.resetFields();
      }
    })
  }
  handleModeChange = (e) => {
    this.setState({pageNum: 1, typecard: e}, () => {
      this.InitQuestionList()
      // console.log(this.props.location.state.tabnum)
    })
  }
  // 上传前
  beforeUpload = (file, fileList) => {
    if (file.size / 1024 / 1024 /1024> 1) {
      return message.error('不允许超过1G!');

    }
    this.setState({iconLoading: true})
  }
  uploadCardImgFront = (e) => {
    let file = e.target.files[0]
    let type = file.name.slice(file.name.lastIndexOf('.') + 1)
    if( (type ==='xlsx' ||type === 'xls'|| type==='XLSX' || type==='XLS')&&e.target.files.length>0) {
        let data = new FormData();
        data.append("file", file);
        this.setState({formdataObj: data,fileObj: file, showUpload: 'reset'}) 
        //fileObj:文件的信息，formdataObj：formdata的file
        // console.log(this.state.formdataObj)
    }else{
      return message.error('只支持xls、xlsx格式')
    }
  }
  resetChoose = () => {
    this.setState({showUpload: 'before',fileObj: {}, formdataObj: {}})
  }
  exportFile = () => {
    // console.log(this.state.formdataObj.get('file'))
    if(this.state.formdataObj.get('file').name){
      let url = this.state.typecard === '1'?'question/writingtest/import':'question/interview/import'
      let data = new FormData();
      data.append("file", this.state.formdataObj.get('file'));
      data.append("konwledgeId", this.state.knowId);
      data.append("subjectId", this.state.questionId);
      axios.post(url, data).then(res => {
        console.log(res.data)
        if(res.data.code !== '200') return message.error(res.data.msg)
        this.setState({showUpload: 'done',msgObj: res.data.data})
      })
    }
  }
  offModal = () => {
    this.setState({showImport: false, showUpload: 'before'},() => {
      this.InitQuestionList()
    })
  }
  downTemplate = () => {
    console.log(urldown)
    const link = document.createElement('a')
    link.style.display="none"
    link.href=urldown+'interviewQuestions.xlsx'
    link.setAttribute('download', 'fd')
    document.body.appendChild(link)
    link.click()
    // window.open(urldown)
  }
    //导出
    exportData(){
      let formData = new FormData();
      formData.append("konwledgeId", this.state.knowId);
      if(this.state.typecard==='1'){
        axios.post(`/question/writingtest/export`,formData,{responseType: 'blob'}).then(res =>{
          const link = document.createElement('a')
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.setAttribute('download', '笔试题列表.xlsx')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
      }else{
        axios.post(`/question/interview/export`,formData,{responseType: 'blob'}).then(res =>{
          const link = document.createElement('a')
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.setAttribute('download', '面试题列表.xlsx')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
      }
  
    }
    //下载模板
    downloadMould(){
      if(this.state.typecard==='1'){
        axios.get(`/question/writingtestDown`,{responseType: 'blob'}).then(res =>{
          const link = document.createElement('a')
            let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', '笔试题模板.xlsx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        })
      }else{
        axios.get(`/question/interviewDown`,{responseType: 'blob'}).then(res =>{
          const link = document.createElement('a')
            let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', '面试题模板.xlsx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        })
      }
    }
  render() {
    let {dataSource,columns,intercolumns,fileObj, msgObj, subjectName, questionId,knowId, typecard, content, topictype, showImport, iconLoading, showUpload, total, pageNum} = this.state
    return (
      <div className="test-question">
        <div className="header-between">
          <span className="header-name">试题管理</span>
          <span className="my-button-txt" onClick={()=>{
              this.props.history.push('/konwledge',{questionId: questionId, knowId, subjectName})
            }}>返回上一级</span>
          </div>
				<Divider />
        <Tabs onChange={this.handleModeChange} activeKey={typecard}  type="card" style={{ marginBottom: 8 }}>
          <TabPane tab="笔试题" key="1"></TabPane>
          <TabPane tab="面试题" key="2"></TabPane>
        </Tabs>
        <div className="search-center">
            <Input value={content} placeholder="搜索题干" onChange={(e) => {this.setState({content: e.target.value})}} />
            {typecard === '1'?
            <Select value={topictype} onChange={(e) => {this.setState({topictype: e})}}>
              <Option value="">全部</Option>
              <Option value="0">单选题</Option>
              <Option value="1">多选题</Option>
            </Select>
            : null
            }
            <Button className='my-button-primary search-right' type='primary' onClick={this.search}>搜索</Button>
            <Button onClick={this.clearSearch}>重置</Button>
            <Button className='my-button-primary rig-btn import-btn' type='primary' onClick={() => { this.exportData() }}>导出</Button>
            <Button className='my-button-primary rig-btn import-btn' type='primary' onClick={() => {
              this.setState({showImport: true})
            }}>批量导入</Button>
            <Button className='my-button-primary rig-btn' type='primary' onClick={() => {
              this.state.typecard === '1'?
              this.props.history.push('/type',{typeQ:'add',knowId: knowId,subjectName,questionId,pageNum: 1}):
              this.props.history.push('/interview',{typeQ:'add', knowId: knowId,subjectName,questionId,pageNum:1})
            }}>新增试题</Button>
            
        </div>
        {typecard === '1'?
          <Table dataSource={dataSource} columns={columns} pagination={false} rowKey={record => record.id} />
          :
          <Table dataSource={dataSource} columns={intercolumns} pagination={false} rowKey={record => record.id} />
        }
        <Pagination className="table-pagination" total={total} current={pageNum} showSizeChanger showQuickJumper pageSizeOptions={['10','20','50','100']} onChange={this.pageChange} onShowSizeChange={this.sizeChange} />
        <div id="filesparet" className="filesparet"></div>
        <Modal title="批量导入" className="batch-modal" width={800} visible={showImport} maskClosable={false} onOk={this.submitOk} onCancel={this.offModal}>
          { showUpload === 'before'? // 上传
          <div className="modal-content">
            <Icon type="file-excel" className="file-icon" />
            <p>下载模版并完善信息后，可将文件在此处上传，支持xls、xlsx格式</p>
            <Button type="primary"  loading={iconLoading} className="my-button-primary upload-btns">
            <input type="file" className="upload-file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" onChange={this.uploadCardImgFront} />
            选择文件</Button>
          </div>
          :showUpload === 'reset'? // 导入
          <div className="modal-content">
            <Icon type="file-excel" className="file-icon upload-icon" />
            <p>{fileObj.name}</p>
            <Button type="primary" loading={iconLoading} onClick={this.exportFile} className="my-button-primary export-rig">导入</Button>
            <Button onClick={this.resetChoose} >重新选择</Button>
          </div>:showUpload === 'done'? //成功
          <div className="modal-content"> 
            <p>成功导入{msgObj.success}个试题，失败{msgObj.fail}个试题</p>
            <Button type="primary" onClick={this.offModal} className="my-button-primary">完成</Button>
          </div>:''
          }
          {
            typecard === '1'?
            <span style={{ color: '#277fff',cursor: 'pointer'}} onClick={() => { this.downloadMould() }}>下载模版</span>
            // href={urldown+'writingTesting.xlsx'}
            :
            <span style={{ color: '#277fff',cursor: 'pointer'}} onClick={() => { this.downloadMould() }}>下载模版</span>
            // href={urldown+'interviewQuestions.xlsx'}
          }
        </Modal>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  // console.log(state.tabnum)
  return {
    tabnum: state.tabnum
  }
}
export default Form.create()(connect(mapStateToProps)(TestQuestions))